@if (evento) {
  <article>
    <div class="header-section">
      <a routerLink="/eventi" class="breadcrumb">&larr; Eventi</a>
      <h1 class="title">{{ evento.titolo }}</h1>
      <p class="subtitle">
        <time [attr.datetime]="evento.dataInizio">{{ evento.dataInizio | date: "dd MMMM yyyy" }}</time>
        @if (showEndDate()) {
          - <time [attr.datetime]="evento.dataFine">{{ evento.dataFine | date: "dd MMMM yyyy" }}</time>
        }
        &middot;
        <a
          [href]="getMapsUrl(evento.posizione)"
          target="_blank"
          rel="noopener"
          class="posizione-link"
          >{{ evento.posizione }}</a
        >
      </p>
    </div>

    <div class="evento-content">
      <div class="left-column">
        <div class="wide-image">
          <img [src]="getImageUrl(evento.immagineWide)" [alt]="evento.titolo" />
        </div>
        @if (evento.iscrizioniAperte) {
          @if (evento.linkIscrizione) {
            <a
              [href]="evento.linkIscrizione"
              target="_blank"
              rel="noopener"
              class="btn-iscriviti"
              >Iscriviti</a
            >
          } @else {
            <a [routerLink]="['iscrizione']" class="btn-iscriviti">Iscriviti</a>
          }
        } @else {
          <p class="iscrizioni-chiuse">Le iscrizioni apriranno a breve</p>
        }
      </div>

      <div class="right-column">
        <div class="descrizione" [innerHTML]="descrizioneHtml"></div>

        @if (evento.contatti?.length > 0) {
          <div class="contatti-section">
            <h3>Contatti</h3>
            @for (contatto of evento.contatti; track contatto.id) {
              <div class="contatto">
                <span class="contatto-nome">{{ contatto.nome }}</span>
                <a [href]="'tel:' + contatto.numero" class="contatto-numero">{{
                  contatto.numero
                }}</a>
              </div>
            }
          </div>
        }

        @if (evento.immaginiExtra?.length > 0) {
          <div class="extra-images">
            <div class="extra-images-scroll">
              @for (img of evento.immaginiExtra; track img.id) {
                <img [src]="getImageUrl(img.immagine)" [alt]="evento.titolo" />
              }
            </div>
          </div>
        }
      </div>
    </div>
  </article>
} @else {
  <div class="loading">
    <p>Caricamento...</p>
  </div>
}
